import data from "./user.json";

export const UserCreate = data.UserCreate;
export const UserUpdate = data.UserUpdate;
